export const maxLength = 100;
